<p-dialog #dialog [header]="'Thêm mới trọng số'" [(visible)]="isShow" [modal]="true"
  [styleClass]="'ag-modal force-full-width'" [style]="{'width': '1200px'}" closeIcon="ci ci-close"
  maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true" [autoZIndex]="true">
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>

      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="categoryId">{{'WeightConfiguration.Service' | translate}} <span style="color: red;">*</span></label>
          <p-dropdown [options]="listCategory" [(ngModel)]="itemDetail.categoryId" [filter]="true" filterBy="label,value" appendTo="body" (onChange)="onChangeCategory()"
            formControlName="categoryId">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="status">{{'WeightConfiguration.Status' | translate}}</label>
          <p-dropdown [options]="listStatus" [(ngModel)]="itemDetail.status" [filter]="true" filterBy="label,value" appendTo="body" 
            formControlName="status">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="productId">{{'WeightConfiguration.Product' | translate}} <span style="color: red;">*</span></label>
          <p-dropdown [options]="listProduct" [(ngModel)]="itemDetail.productId" [filter]="true" filterBy="label,value" appendTo="body" 
            formControlName="productId">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="unitCode">{{'WeightConfiguration.Unit' | translate}} <span style="color: red;">*</span></label>
          <p-multiSelect [options]="listUnit" [(ngModel)]="unitCode" formControlName="unitCode"
            [virtualScroll]="true" [virtualScrollItemSize]="10"
            optionLabel="label" optionValue="value" />
          <!-- <p-dropdown [options]="listUnit" [(ngModel)]="itemDetail.unitCode" [filter]="true" filterBy="label,value" appendTo="body" 
            [virtualScroll]="true"
            formControlName="unitCode">
          </p-dropdown> -->
        </div>
        <div class="field col-12 md:col-3">
          <p-checkbox [(ngModel)]="itemDetail.percentConfig" label="Cấu hình trọng số theo đơn vị (%)" formControlName="percentConfig" name="percentConfig" (onChange)="onChangePercentConfig()" appendTo="body"  
            style="margin-top: 25px;" [binary]="true" />
        </div>
        <div class="field col-12 md:col-3">
          <p-checkbox [(ngModel)]="itemDetail.amountConfig" label="Cấu hình trọng số theo đơn vị (VNĐ)" formControlName="amountConfig" name="amountConfig" (onChange)="onChangeAmountConfig()" appendTo="body" 
            style="margin-top: 25px;" [binary]="true" />
        </div>
        <div class="field col-12 md:col-6"></div>
        <div *ngIf="itemDetail.percentConfig" class="field col-12 md:col-6">
          <label for="salesWeight">{{'WeightConfiguration.SalesWeight' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.salesWeight" formControlName="salesWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.salesWeight" 
            formControlName="salesWeight"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="2" /> 
        </div>
        <div *ngIf="itemDetail.amountConfig" class="field col-12 md:col-6">
          <label for="revenue">{{'WeightConfiguration.Revenue' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.salesWeight" formControlName="salesWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.revenue" 
            formControlName="revenue"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="0" /> 
        </div>
        <div class="field col-12 md:col-6">
          <label for="paymentPeriod">{{'WeightConfiguration.PaymentPeriod' | translate}}</label>
          <p-dropdown [options]="listPeriod" [(ngModel)]="itemDetail.paymentPeriod" [filter]="true" filterBy="label,value" appendTo="body" [showClear]="true"
            formControlName="paymentPeriod">
          </p-dropdown>
        </div>
        <div *ngIf="itemDetail.percentConfig" class="field col-12 md:col-6">
          <label for="totalWeight">{{'WeightConfiguration.TotalWeight' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.totalWeight" formControlName="totalWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.totalWeight" 
            formControlName="totalWeight"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="2" /> 
        </div>
        <div *ngIf="itemDetail.amountConfig" class="field col-12 md:col-6">
          <label for="totalRemuneration">{{'WeightConfiguration.TotalRemuneration' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.salesWeight" formControlName="salesWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.totalRemuneration" 
            formControlName="totalRemuneration"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="0" /> 
        </div>
        <div class="field col-12 md:col-6">
          <label for="applyTime">{{'WeightConfiguration.ApplyTime' | translate}} <span style="color: red;">*</span></label>
          <div style="width: 100%; display: flex;">
            <div style="width: 47%;">
              <p-calendar [showIcon]="true" formControlName="startDate" [(ngModel)]="itemDetail.startDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" appendTo="body" />
            </div>
            <div style="width: 6%; margin: auto; text-align: center;"> <span>-</span> </div>
            <div style="width: 47%;">
              <p-calendar [showIcon]="true" formControlName="endDate" [(ngModel)]="itemDetail.endDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" appendTo="body" />
            </div>
          </div>
        </div>
        <div *ngIf="itemDetail.percentConfig" class="field col-12 md:col-6">
          <label for="receivedWeight">{{'WeightConfiguration.ReceivedWeight' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.receivedWeight" formControlName="receivedWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.receivedWeight" 
            formControlName="receivedWeight"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="2" /> 
        </div>
        <div *ngIf="itemDetail.amountConfig" class="field col-12 md:col-6">
          <label for="remunerationReceived">{{'WeightConfiguration.RemunerationReceived' | translate}} <span style="color: red;">*</span></label>
          <!-- <input type="text" pInputText [(ngModel)]="itemDetail.receivedWeight" formControlName="receivedWeight" autocomplete="off"> -->
          <p-inputNumber 
            [(ngModel)]="itemDetail.remunerationReceived" 
            formControlName="remunerationReceived"
            mode="decimal" 
            locale="en-US" 
            [maxFractionDigits]="0" /> 
        </div>
        <div class="field col-12 md:col-6"></div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left">
      </div>
      <div class="col-4 md:col-4 fr">
        <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CLOSE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"></button>

        <!-- <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CONTINUE' | translate}}" icon="pi pi-save"
          *ngIf="itemDetail.id == 0" [disabled]="submitting" class="p-button mr-2 mb-2" (click)="save()"
          authorize="[{'core':'users/1'}]"></button> -->
      </div>
    </div>
  </p-footer>
</p-dialog>
